/**
 * Translates 'a' to '🇦', 'b' to '🇧' and so on.
 *
 * @param {string} letter A single letter, eg. 'a', 'b', 'c' or 'A', 'B', 'C'
 * @returns {string} A letter emoji
 */
function letterToLetterEmoji(letter) {
    return String.fromCodePoint(letter.toLowerCase().charCodeAt(0) + 127365);
}
/**
 * Translates 'pl' to 'PL', 'en-US' to 'US' and so on.
 *
 * @param {string} countryCode A full IETF language tag or a region name
 * @returns {string} A region name
 */
function countryCodeToCountry(countryCode) {
    var country = countryCode.split('-').pop();
    return country.toUpperCase();
}
/**
 * Translates 'pl-PL' to 🇵🇱 and so on.
 *
 * @param {string} countryCode A full IETF language tag or a region name
 * @returns {string} A flag emoji
 */
export default function countryCodeToFlagEmoji(countryCode) {
    if (!countryCode) {
        throw new Error('countryCode is required');
    }
    return Array.from(countryCodeToCountry(countryCode)).map(letterToLetterEmoji).join('');
}
